import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Stack } from '@koob/margaret';
import { Text } from 'ui';
import { TextField } from 'components/Fields';
import { KoobButton } from '@koob/ui';
import { Link } from 'react-router-dom';

const SettingRequestForm = ({
  onSubmit,
  settingRequest,
  disabledCreate = false,
}) => {
  const { t } = useTranslation('settingRequest');

  return (
    <Formik
      initialValues={{
        displayName: settingRequest?.displayName ?? '',
      }}
      enableReinitialize
      onSubmit={onSubmit}
      validationSchema={Yup.object().shape({
        displayName: Yup.string().required(t('errors:required')),
      })}
    >
      {({ isSubmitting }) => (
        <Form>
          <Stack direction="column" gutterSize={1} size="full" alignX="stretch">
            <Stack alignX="space-between" alignY="center" gutterSize={1}>
              <Text type="h1">{t('newSettingRequest')}</Text>
            </Stack>
            <TextField label={t('name')} name="displayName" />
            <Stack gutterSize={1}>
              <KoobButton
                type="submit"
                variant="primary"
                loading={isSubmitting}
                disabled={disabledCreate}
              >
                {t('misc:saveChanges')}
              </KoobButton>
              <KoobButton variant="secondary" type="button" asChild>
                <Link to="/settings/hotels/">{t('misc:cancel')}</Link>
              </KoobButton>
            </Stack>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default SettingRequestForm;
